



























































import { Budget, CategoryBudget, Census } from "@/api";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import { VForm } from "@/common/vuetify_types";
import { calculateBudget } from "@/tool/budgetCalculator";
import {
  floatOnly,
  noSpace,
  requiredString,
  requriedNumber,
} from "@/tool/validation";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    ConfirmationModule,
  },
})
export default class BudgetForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() data!: CategoryBudget;
  @Prop() custom!: boolean;
  @Prop() dindex!: number;
  @Prop() departmentId!: number;
  @Prop() cindex!: number;
  @Prop() census!: number;
  @Prop() validate!: boolean;

  @Watch("data", { immediate: true, deep: true })
  onUpdateData(newVal: CategoryBudget) {
    this.category = newVal;
    this.budget = newVal.budget;
    this.ppd = newVal.ppd;
  }

  @Watch("validate", { immediate: true, deep: true })
  onUpdatValidate(nvewVal: boolean) {
    if (nvewVal) {
      this.form.validate();
    }
  }

  @Watch("census", { immediate: true, deep: true })
  onCensusUpdate(newVal: number) {
    if (newVal > 0) {
      this.updateAllBudgets();
    }
  }

  category = this.data;
  prevCategory = JSON.parse(JSON.stringify(this.data));
  reqString = [requiredString, noSpace];
  reqFloat = [requriedNumber, floatOnly];
  saving = false;
  confirm = false;
  budget = this.data.budget;
  ppd = this.data.ppd;

  checkZeroPpd() {
    if (this.form.validate()) {
      const ppd = this.category.ppd;
      if (ppd <= 0) {
        this.confirm = true;
        return;
      }
      this.saveBudget();
    }
  }

  finalBudget() {
    if (this.custom) {
      return this.budget;
    } else {
      if (this.category.ppd > 0 && this.census > 0) {
        return calculateBudget(this.category.ppd, this.census);
      } else {
        return 0;
      }
    }
  }

  get companyCensus() {
    const companyCensus = this.$store.getters[
      "categoryBudget/census"
    ] as Census;
    return companyCensus;
  }

  async saveBudget() {
    this.confirm = false;
    if (this.form.validate()) {
      const census = parseInt(this.census.toString());
      const payload: Budget = {
        catId: this.category.category_id,
        budget: this.category.budget,
        ppd: this.category.ppd,
        balance: this.category.budget,
        glCode: this.category.glCode,
      };

      if (!census || census === 0) {
        this.$emit("error");
        return;
      }
      this.saving = true;
      await this.$store.dispatch("categoryBudget/addBudgetToCategroy", {
        departmentId: this.departmentId,
        categoryId: this.category.category_id,
        requestBody: payload,
      });
      this.saving = false;
    }
  }

  updateAllBudgets() {
    if (this.custom) this.ppd = 0;
    this.category.ppd = parseFloat(this.ppd.toString());
    this.budget = this.finalBudget();
    this.category.budget = this.budget;
    this.category.balance = this.category.budget;
    this.budget = this.category.balance;
    this.$emit("updateAllBudgets", {
      cat: this.category,
      dindex: this.dindex,
      cindex: this.cindex,
    });
  }
}
